var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{staticClass:"process-steps"},_vm._l((_vm.displaySteps),function(step,i){return _c('li',{key:i,staticClass:"process-card"},[_c('div',{staticClass:"process-num"},[_vm._v(_vm._s(_vm.pad(i + 1)))]),_c('h3',[_vm._v(_vm._s(_vm.titleOf(step)))]),_c('p',[_vm._v(_vm._s(_vm.bodyOf(step)))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }